import React, { useState } from "react";
import { useCapital } from "../useJournal";

const s = {
  card: { background: "white", border: "1px solid #e5e7eb", borderRadius: 8, padding: 20, marginBottom: 16 },
  label: { fontSize: 11, color: "#6b7280", fontWeight: 600, marginBottom: 3, display: "block", textTransform: "uppercase" },
  input: { width: "100%", border: "1px solid #d1d5db", borderRadius: 6, padding: "7px 10px", fontSize: 13 },
  btn: (c) => ({ padding: "8px 18px", borderRadius: 6, border: "none", cursor: "pointer", fontWeight: 600, fontSize: 13, background: c === "green" ? "#16a34a" : c === "red" ? "#dc2626" : "#6b7280", color: "white" }),
};

const fmt = n => "₹" + Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function CapitalPage() {
  const { entries, loading, addEntry, deleteEntry, totalCapital } = useCapital();
  const [form, setForm] = useState({ date: new Date().toISOString().split("T")[0], type: "deposit", amount: "", notes: "" });
  const [saving, setSaving] = useState(false);

  async function handleAdd() {
    if (!form.amount || isNaN(form.amount)) return alert("Enter a valid amount");
    setSaving(true);
    await addEntry({ ...form, amount: parseFloat(form.amount) });
    setForm(f => ({ ...f, amount: "", notes: "" }));
    setSaving(false);
  }

  return (
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 20 }}>
        {[
          { label: "Total Capital", value: fmt(totalCapital), color: "#1d4ed8" },
          { label: "Total Deposits", value: fmt(entries.filter(e=>e.type==="deposit").reduce((s,e)=>s+e.amount,0)), color: "#16a34a" },
          { label: "Total Withdrawals", value: fmt(entries.filter(e=>e.type==="withdrawal").reduce((s,e)=>s+e.amount,0)), color: "#dc2626" },
        ].map(c => (
          <div key={c.label} style={{ ...s.card, textAlign: "center", marginBottom: 0 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: c.color, fontFamily: "monospace" }}>{c.value}</div>
            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>{c.label}</div>
          </div>
        ))}
      </div>

      <div style={s.card}>
        <div style={{ fontWeight: 700, marginBottom: 16 }}>Add Funds Movement</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 2fr auto", gap: 12, alignItems: "end" }}>
          <div><label style={s.label}>Date</label><input type="date" style={s.input} value={form.date} onChange={e => setForm(f=>({...f,date:e.target.value}))} /></div>
          <div><label style={s.label}>Type</label><select style={s.input} value={form.type} onChange={e => setForm(f=>({...f,type:e.target.value}))}><option value="deposit">Deposit</option><option value="withdrawal">Withdrawal</option></select></div>
          <div><label style={s.label}>Amount (₹)</label><input type="number" style={s.input} value={form.amount} onChange={e => setForm(f=>({...f,amount:e.target.value}))} /></div>
          <div><label style={s.label}>Notes</label><input type="text" style={s.input} value={form.notes} onChange={e => setForm(f=>({...f,notes:e.target.value}))} /></div>
          <button style={s.btn("green")} onClick={handleAdd} disabled={saving}>{saving?"...":"Add"}</button>
        </div>
      </div>

      <div style={s.card}>
        <div style={{ fontWeight: 700, marginBottom: 12 }}>Capital History</div>
        {loading ? <div style={{color:"#9ca3af"}}>Loading...</div> : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead><tr style={{borderBottom:"1px solid #e5e7eb"}}>{["Date","Type","Amount","Notes","Running Total",""].map(h=><th key={h} style={{padding:"6px 8px",textAlign:"left",fontSize:11,color:"#6b7280",fontWeight:600}}>{h}</th>)}</tr></thead>
            <tbody>
              {[...entries].reverse().reduce((acc,e)=>{const prev=acc.length>0?acc[acc.length-1].running:0;acc.push({...e,running:prev+(e.type==="deposit"?e.amount:-e.amount)});return acc;},[]).reverse().map(e=>(
                <tr key={e.id} style={{borderBottom:"1px solid #f3f4f6"}}>
                  <td style={{padding:"8px"}}>{e.date}</td>
                  <td style={{padding:"8px"}}><span style={{color:e.type==="deposit"?"#16a34a":"#dc2626",fontWeight:600}}>{e.type==="deposit"?"↑ Deposit":"↓ Withdrawal"}</span></td>
                  <td style={{padding:"8px",fontFamily:"monospace"}}>{fmt(e.amount)}</td>
                  <td style={{padding:"8px",color:"#6b7280"}}>{e.notes}</td>
                  <td style={{padding:"8px",fontFamily:"monospace",fontWeight:600}}>{fmt(e.running)}</td>
                  <td style={{padding:"8px"}}><button onClick={()=>deleteEntry(e.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#dc2626",fontSize:12}}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
